import Waves from "./Waves";

export * from "./Anchor";
export * from "./BookA";
export * from "./CircleParking";
export * from "./CircleParkingOff";
export * from "./Compass";
export * from "./Dumbbell";
export * from "./Earth";
export * from "./FerrisWheel";
export * from "./Footprints";
export * from "./Fuel";
export * from "./Gavel";
export * from "./Globe";
export * from "./Locate";
export * from "./LocateFixed";
export * from "./LocateOff";
export * from "./Map";
export * from "./Navigation";
export * from "./Navigation2";
export * from "./Navigation2Off";
export * from "./NavigationOff";
export * from "./ParkingMeter";
export * from "./PinOff";
export * from "./RailSymbol";
export * from "./RollerCoaster";
export * from "./Route";
export * from "./RouteOff";
export * from "./Scale";
export * from "./Ship";
export * from "./ShipWheel";
export * from "./SquareM";
export * from "./SquareParking";
export * from "./SquareParkingOff";
export * from "./TrainFrontTunnel";
export * from "./TrainTrack";
export * from "./UtensilsCrossed";
export * from "./Waves";

export const Mapsss = {
  Waves,
};
